<template>
  <a-select class="item-input card-shadow" placeholder="业务筛选" allowClear
    v-model="vmodel"
    @change="changeHandle">
    <a-select-option
      v-for="(item, ind) in data"
      :key="ind"
      :value="item.id"> {{item.business_title_zh}} </a-select-option>
  </a-select>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: undefined
    }
  },
  computed: mapGetters([
    'selectAreaList'
  ]),
  data () {
    return {
      code: '',
      vmodel: '',
      data: [],
      cond: {
        page_num: '1',
        page_size: '99'
      }
    }
  },
  watch: {
    vmodel (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.vmodel = this.value
    this.initHandle()
  },
  methods: {
    changeHandle (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },
    initHandle () {
      if (this.selectAreaList.length) {
        this.data = this.selectAreaList
      } else {
        this.readList()
      }
    },
    readList () {
      this.get({
        url: 'businessRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        if (res.code) {
          this.data = res.data.items
          this.$store.commit('cacheSelectData', {
            key: 'selectAreaList',
            value: res.data.items
          })
        } else {
          this.data = []
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Models/comps/selectedAreas.vue